﻿angular.module('taric.quota', [])
    .component('ordernumberButton', require('./components/ordernumber-button'))
    .component('ukOrdernumberButton', require('./components/uk-ordernumber-button'))
    .component('orderNumberPicker', require('./components/order-number-picker'))
    .filter('orderNumberTypeahead', require('./filters/order-number-typeahead-filter'))
    .factory('orderQuotaModal', require('./modals/order-quota'))
    .factory('ukOrderQuotaModal', require('./modals/uk-order-quota'))
    .factory('quotaModals', require('./modals/modals'))
    .factory('quotaDataService', require('./services/quota-data'))
    ;